import { render } from "./En020.vue?vue&type=template&id=48adb072"
import script from "./En020.vue?vue&type=script&lang=js"
export * from "./En020.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__